import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bf046b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video" }
const _hoisted_2 = { class: "video_radio" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "video_radio_title" }, "显示模式：", -1))
const _hoisted_4 = { class: "video_radio" }
const _hoisted_5 = { class: "video_template" }
const _hoisted_6 = { class: "c_form_item mpiu_tobody" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "c_form_item_title" }, "拓展图标：", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "建议图片尺寸30px*30px、小于2M 支持jpg、jpeg、png、gif", -1))
const _hoisted_9 = { class: "c_form_item video_input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "c_form_item_title" }, "拓展名称：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(中文两字符, 英文四字符）", -1))
const _hoisted_12 = { class: "c_form_item video_input" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "c_form_item_title" }, "页面高度：", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "c_form_item_desc" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "px"),
  /*#__PURE__*/_createTextVNode(" (PC端) ")
], -1))
const _hoisted_15 = { class: "c_form_item video_input" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "c_form_item_title" }, "实时操作：", -1))
const _hoisted_17 = { class: "c_form_item video_input" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "c_form_item_title" }, "页面地址：", -1))
const _hoisted_19 = { class: "c_form_item video_input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "c_form_item_title" }, "回调地址：", -1))

import { ref, watch, unref } from 'vue';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import { Switch, message, Popover } from 'ant-design-vue';
import { ExternalContent, ExternalPage, ExternalPageClass, ExternalPageVisible } from '../type';
import CUpload from '@/components/CUpload.vue';
import { useRoute } from 'vue-router';
import EventBus from '@/components/EventBus';
import { useSocketStore } from '@/pinia/socket';
import { number } from 'vue-types';

interface IProps {
  modelValue: ExternalContent;
  index: number | string;
}
export interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
export interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalPage',
  props: {
    modelValue: null,
    index: null
  },
  emits: ['update:modelValue', 'click:save'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: ExternalContent;
  index: number | string;
};

const aSwitch = Switch;
const aPopover = Popover;
const route = useRoute();


const form = ref<ExternalPage>({
  menu_type: true,
  expand_type: false,
  full_type: false,
  popup: false,
  expand_url: '',
  expand_name: '',
  height: '',
  content_url: '',
  callback_url: '',
  eject: 0,
});
const formVisible = ref<ExternalPageVisible>({
  popup: false,
  expand_url: false,
  expand_name: false,
  height: false,
  control: false,
  content_url: false,
  callback_url: false,
});

watch(
  () => form.value.menu_type,
  (newVal) => {
    if (newVal) {
      form.value.full_type = false;
    }
    formVisible.value.height = newVal;
  }
);

watch(
  () => form.value.expand_type,
  (newVal) => {
    if (newVal) {
      form.value.full_type = false;
    }
    formVisible.value.popup = newVal;
    formVisible.value.expand_url = newVal;
    formVisible.value.height = newVal;
  }
);

watch(
  () => form.value.full_type,
  (newVal) => {
    if (newVal) {
      form.value.menu_type = false;
      form.value.expand_type = false;
    }
    formVisible.value.control = newVal;
  }
);

const external = new ExternalPageClass(unref(props.modelValue));
form.value = external;

watch(form.value, (newVal) => {
  emit('update:modelValue', newVal);
});

const onChangeName = () => {
  const str = form.value.expand_name;
  // eslint-disable-next-line no-control-regex
  let cArr = str.match(/[^\x00-\xff]/gi);
  if (str.length + (cArr == null ? 0 : cArr.length) > 4) {
    message.destroy();
    message.error('菜单名称中文不能大于2个字符 ，英文不能大于4个字符！');
    if (cArr == null) {
      form.value.expand_name = str.substr(0, 4);
    } else {
      form.value.expand_name = str.substr(0, 2);
    }
  }
};
// upload module

function getBase64(img: Blob, callback: (base64Url: string) => void) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
}
const fileList = ref([]);
const loading = ref<boolean>(false);
const handleChange = (info: FileInfo): void => {
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  }
  if (info.file.status === 'done') {
    getBase64(info.file.originFileObj, (base64Url: string) => {
      if (info.file?.response?.code === 200) {
        form.value.expand_url = info.file?.response?.data.url;
      } else {
        message.error(info.file?.response?.message);
      }
      loading.value = false;
    });
  }
  if (info.file.status === 'error') {
    loading.value = false;
    message.error('上传失败');
  }
};
const imageDel = () => {
  form.value.expand_url = '';
};

const socketStore = useSocketStore();
const sendPopOrClose = (type: number) => {
  form.value.eject = type;
  emit('click:save');
  const info = {
    type: 'custom_notice',
    studio_id: route.params.studioId,
    data: {
      type: 'full_screen_assistance',
      status: type,
      index: Number(props.index),
    },
  };
  socketStore.socket?.send(info);
};

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_checkbox, {
        class: "video_radio_c",
        checked: form.value.menu_type,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((form.value.menu_type) = $event))
      }, {
        default: _withCtx(() => [
          _createTextVNode("菜单显示")
        ]),
        _: 1
      }, 8, ["checked"]),
      _createVNode(_component_a_checkbox, {
        class: "video_radio_c",
        checked: form.value.expand_type,
        "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((form.value.expand_type) = $event))
      }, {
        default: _withCtx(() => [
          _createTextVNode("拓展显示")
        ]),
        _: 1
      }, 8, ["checked"]),
      _createVNode(_component_a_checkbox, {
        class: "video_radio_c",
        checked: form.value.full_type,
        "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((form.value.full_type) = $event))
      }, {
        default: _withCtx(() => [
          _createTextVNode("全屏显示")
        ]),
        _: 1
      }, 8, ["checked"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createTextVNode(" 默认弹出： "),
      _createVNode(_unref(aSwitch), {
        checked: form.value.popup,
        "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((form.value.popup) = $event))
      }, null, 8, ["checked"])
    ], 512), [
      [_vShow, formVisible.value.popup]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(CUpload, {
          "file-list": fileList.value,
          "handle-change": (info) => handleChange(info),
          loading: loading.value,
          "image-name": form.value.expand_url,
          "click-stop": imageDel,
          class: "ant_upload"
        }, null, 8, ["file-list", "handle-change", "loading", "image-name"]),
        _createVNode(_unref(aPopover), { placement: "right" }, {
          content: _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(QuestionCircleFilled), { class: "mod_tooltip" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_a_input, {
          size: "large",
          class: "c_input video_input_title",
          value: form.value.expand_name,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.expand_name) = $event)),
          onChange: onChangeName
        }, null, 8, ["value"]),
        _createVNode(_unref(aPopover), { placement: "right" }, {
          content: _withCtx(() => [
            _hoisted_11
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(QuestionCircleFilled), { class: "mod_tooltip" })
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, formVisible.value.expand_url]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_component_a_input, {
        size: "large",
        class: "c_input video_input_title",
        value: form.value.height,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.height) = $event))
      }, null, 8, ["value"]),
      _hoisted_14
    ], 512), [
      [_vShow, !formVisible.value.control]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createVNode(_component_a_button, {
        class: "c_form_item_btn",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (sendPopOrClose(1)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("弹出")
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        class: "c_form_item_btn",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (sendPopOrClose(0)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("隐藏")
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, formVisible.value.control]
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createVNode(_component_a_input, {
        size: "large",
        class: "c_input",
        value: form.value.content_url,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.content_url) = $event))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createVNode(_component_a_input, {
        size: "large",
        class: "c_input",
        value: form.value.callback_url,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.callback_url) = $event))
      }, null, 8, ["value"])
    ])
  ]))
}
}

})